"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Events() {
  const {
    ref: leftCardRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: rightCardRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="събития" className="dark relative bg-cover bg-center text-foreground py-20 px-6 overflow-hidden" style={{
    backgroundImage: "url('https://mishmashinterpred.com/wp-content/uploads/2026/02/restaurant_celebration_bg.webp')"
  }}>
      <div className="absolute inset-0 bg-black/60 z-0"></div>
      <div className="container relative z-10 mx-auto max-w-[78rem]">
        <div className="text-center mb-16 relative">
          <div className="absolute inset-0 -inset-x-8 -inset-y-4 bg-black/40 backdrop-blur-sm rounded-[2rem] -z-10"></div>
          <h2 className="text-[40px] font-display font-bold tracking-tight leading-[1.2] mb-4 text-white">Празнувайте при нас - с вкус и без грижи!</h2>
          <p className="text-[16px] leading-[1.5] text-white/90 max-w-2xl mx-auto">
            Организирайте вашето следващо събитие при нас – предлагаме гъвкави решения за частни и фирмени празненства в модерна и приятелска атмосфера.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {}
          <div ref={leftCardRef} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateX(0)" : "translateX(-40px)"
        }}>
            <Card className="group bg-[#2A3845] hover:bg-[#2F3D4C] rounded-[2rem] shadow-clay hover:shadow-clay-hover transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1.5 overflow-hidden border-none">
              <div className="relative h-64 overflow-hidden rounded-t-[2rem]">
                <img src="https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-6ce3c7fc10e2caa4da36f325072c2724-V.webp" alt="Частна вечеря" className="w-full h-full object-cover transition-transform duration-500 ease-[var(--ease-smooth)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-primary/5 pointer-events-none"></div>
                <div className="absolute top-4 right-4 bg-accent/90 backdrop-blur-sm rounded-full p-3 shadow-soft">
                  <ArrowRight className="size-5 text-white" />
                </div>
              </div>
              <CardContent className="p-8">
                <h3 className="text-[26px] font-display font-bold leading-[1.3] mb-3 !text-[hsl(17,88%,40%)]">
                  Частни събития
                </h3>
                <p className="text-[16px] leading-[1.5] mb-6 !text-[hsl(0,0%,100%)]">
                  Рождени дни, годишнини, семейни тържества – създайте незабравими спомени в нашето уютно пространство с персонализирано меню и обслужване.
                </p>
                <Link to="/ContactPage">
                  
                </Link>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={rightCardRef} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateX(0)" : "translateX(40px)"
        }}>
            <Card className="group bg-[#2A3845] hover:bg-[#2F3D4C] rounded-[2rem] shadow-clay hover:shadow-clay-hover transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1.5 overflow-hidden border-none">
              <div className="relative h-64 overflow-hidden rounded-t-[2rem]">
                <img src="https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-0147514a8efc2fafe02a54fdd04df7d4-V.webp" alt="Фирмен обяд" className="w-full h-full object-cover transition-transform duration-500 ease-[var(--ease-smooth)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-primary/5 pointer-events-none"></div>
                <div className="absolute top-4 right-4 bg-primary/90 backdrop-blur-sm rounded-full p-3 shadow-soft">
                  <ArrowRight className="size-5 text-white" />
                </div>
              </div>
              <CardContent className="p-8">
                <h3 className="text-[26px] font-display font-bold leading-[1.3] mb-3 !text-[hsl(17,88%,40%)]">
                  Фирмени събития
                </h3>
                <p className="text-[16px] leading-[1.5] mb-6 !text-[hsl(0,0%,100%)]">
                  Бизнес обяди, тиймбилдинги, корпоративни празници – предлагаме професионална организация и качествено обслужване за вашия екип.
                </p>
                <Link to="/ContactPage">
                  
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}